module.exports = __webpack_public_path__ + "img/p-three-step-06.d3a4c71f.png";